import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';
@Injectable()
export class attendanceService {

  user:any;
  constructor(private http: HttpClient,private _global:Globals) {
   
  }
  readonly rootUrl = this._global.siteUrl;

 

  getAttendance(obj){ 
    console.log("kjdfnkdnfkn");
    console.log(obj);
  return this.http.post(this.rootUrl+'attendance/', obj);
  
  }

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/attendance.service.ts